import { render, staticRenderFns } from "./TutoresEdicionPaciente.vue?vue&type=template&id=87fe3418&scoped=true"
import script from "./TutoresEdicionPaciente.vue?vue&type=script&lang=js"
export * from "./TutoresEdicionPaciente.vue?vue&type=script&lang=js"
import style0 from "./TutoresEdicionPaciente.vue?vue&type=style&index=0&id=87fe3418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe3418",
  null
  
)

export default component.exports